export default "__VITE_ASSET__D_h5MJO$__"